import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M12 1c5.042 0 7.606.346 8.556 2.167-.762-.294-1.593-.492-2.468-.63C16.41 2.274 14.376 2.2 12 2.2s-4.41.073-6.089.338c-.875.137-1.705.335-2.467.629C4.394 1.346 6.958 1 12 1"
                    fill="currentColor"
                />
                <path d="M5 9.1v1.8h14V9.1z" fill="currentColor" />
                <path d="M5.5 14.4h7v-1.8h-7z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C2.556 4 .226 5.188 1.207 13.5 2.188 21.813 3.537 23 12 23s9.812-1.187 10.793-9.5C23.774 5.188 21.443 4 12 4M3.83 7.029c-.806.657-1.333 2.045-.835 6.26.243 2.062.497 3.556.842 4.67.338 1.09.724 1.682 1.15 2.057.428.377 1.072.69 2.215.897 1.163.211 2.698.287 4.798.287s3.635-.076 4.798-.287c1.143-.207 1.787-.52 2.215-.897.426-.375.812-.966 1.15-2.057.345-1.114.599-2.608.842-4.67.498-4.215-.029-5.603-.836-6.26-.465-.379-1.248-.716-2.64-.936C16.143 5.876 14.345 5.8 12 5.8s-4.144.075-5.528.293c-1.393.22-2.176.557-2.641.936"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CardLinesStackedOutlinedSize24Glyph.displayName = 'CardLinesStackedOutlinedSize24Glyph';
